/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useNavigate } from 'react-router-dom';
import React from 'react';

import classNames from 'classnames';

import brandLogoUrl from './dzx.png';

import styles from './index.module.less';

export { brandLogoUrl };

export interface CozeBrandProps {
  isWhite?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function CozeBrand({ isWhite, className, style }: CozeBrandProps) {
  const navigate = useNavigate();
  const navBack = () => {
    navigate('/');
  };
  return (
    <button
      type="button"
      onClick={navBack}
      className={classNames(
        styles['coze-brand'],
        styles['brand-button'],
        isWhite && styles['brand-white'],
        className,
      )}
      style={style}
    >
      <img src={brandLogoUrl} className={styles['brand-icon']} alt="" />
      <span>大招象</span>
    </button>
  );
}
